import { useMemo } from 'react';
import { getData as getCountries } from '@bizzabo/country-list';
import { getBannedCountriesRequest } from './bannedCountries';
import type { BannedCountiesTypes } from './bannedCountries';
import { useQuery } from 'react-query';

type Country = {
    name: string;
    code: string;
};

type MappedCountry = {
    label: string;
    value: string;
};

const mapCountry = (country: Country): MappedCountry => ({
    label: country.name,
    value: country.code,
});

const countries: MappedCountry[] = getCountries().map(mapCountry);

export const useCountries = (accountId: number, eventId: number) => {
    const { data } = useQuery<BannedCountiesTypes>(
        ['banned_countries', accountId, eventId],
        () => getBannedCountriesRequest(accountId, eventId),
        { enabled: !!accountId && !!eventId, retry: 1 }
    );
    const bannedCountriesMap =
        data?.values?.reduce(
            (countryCodes, { value }) => ({ ...countryCodes, [value]: true }),
            {}
        ) || {};
    return getCountries()
        .filter((country: Country) => !bannedCountriesMap[country.code])
        .map(mapCountry);
};

type CountryByCountryCode = (value: string) => MappedCountry | null;
export const useCountryByCountryCode: CountryByCountryCode = (value = '') => {
    const country = useMemo(
        () => countries.find(country => country.value === value),
        [value, countries]
    );
    return country ? country : null;
};
